/* Direct Team Sports: personalization fields for the Horizon theme.
   Works with blocks/dts-personalization.liquid.
   Shows and requires the Name and Number line-item inputs only when the paid
   personalization option is selected (the option whose values include "No Thanks"
   is set to anything else). Hidden inputs are disabled so they never submit.
   The box carries data-option-name with the exact option name; Horizon's variant
   picker marks every radio and select option with the same data-option-name.
   Native "required" validation blocks add to cart until the fields are filled,
   because the inputs are tied to the product form with the form attribute. */
(function () {
  if (window.__dtsPerso) {
    window.__dtsPerso();
    return;
  }

  function rootFor(box) {
    return box.closest('.shopify-section') || box.closest('dialog') || document;
  }

  function selectedValue(root, optionName) {
    var radios = root.querySelectorAll('input[type="radio"][data-option-name]');
    for (var i = 0; i < radios.length; i++) {
      if (radios[i].dataset.optionName === optionName && radios[i].checked) {
        return radios[i].value;
      }
    }
    var options = root.querySelectorAll('select option[data-option-name]');
    for (var j = 0; j < options.length; j++) {
      if (options[j].dataset.optionName === optionName && options[j].selected) {
        return options[j].value;
      }
    }
    return null;
  }

  function isYes(value) {
    return value != null && value.toLowerCase().indexOf('no thanks') === -1;
  }

  function update(box) {
    var value = selectedValue(rootFor(box), box.dataset.optionName);
    if (value === null) return;
    var show = isYes(value);
    box.hidden = !show;
    var inputs = box.querySelectorAll('[data-dts-perso-input]');
    for (var i = 0; i < inputs.length; i++) {
      inputs[i].disabled = !show;
      if (show) {
        inputs[i].setAttribute('required', 'required');
      } else {
        inputs[i].removeAttribute('required');
      }
    }
  }

  function updateAll() {
    var boxes = document.querySelectorAll('[data-dts-perso-box]');
    for (var i = 0; i < boxes.length; i++) {
      update(boxes[i]);
    }
  }

  var timer;
  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(updateAll, 30);
  }

  window.__dtsPerso = updateAll;

  document.addEventListener(
    'change',
    function (event) {
      var t = event.target;
      if (t && t.matches && (t.matches('input[type="radio"][data-option-name]') || t.matches('select'))) {
        schedule();
      }
    },
    true
  );

  // Horizon re-renders the variant picker after a selection; recheck when it does.
  var observer = new MutationObserver(schedule);
  observer.observe(document.documentElement, { childList: true, subtree: true });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', updateAll);
  } else {
    updateAll();
  }
})();
